const initialState = {
  data: null,
};

const assistEmitedData = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ASSISTEMITEDDATA':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default assistEmitedData;
